import { render, staticRenderFns } from "./RightConent.vue?vue&type=template&id=cf970d8e&scoped=true&"
import script from "./RightConent.vue?vue&type=script&lang=ts&"
export * from "./RightConent.vue?vue&type=script&lang=ts&"
import style0 from "./RightConent.vue?vue&type=style&index=0&id=cf970d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf970d8e",
  null
  
)

export default component.exports